import React, { useCallback, useState } from 'react';
import { AppButton, Box, BoxExtendedProps, RoundCloseIcon, Text, useResponsive, WarningCard } from '@common-fe/common-fe';

import ReviewAddressModal from '@/modules/employee/Employee/PersonalInformation/PreferredMailingAddress/components/ReviewAddressModal';

interface Props extends BoxExtendedProps {
  showWarning?: boolean;
}

const FixYourAddressWarningCard: React.FC<Props> = ({ showWarning, ...props }) => {
  const { isMobile } = useResponsive();
  const [isReviewModalOpen, setIsReviewModalOpen] = useState(false);

  const handleOpenModal = useCallback(() => {
    setIsReviewModalOpen(true);
  }, []);

  const handleCloseModal = useCallback(() => {
    setIsReviewModalOpen(false);
  }, []);

  return (
    <>
      {showWarning ? (
        <WarningCard
          testId="fix-your-address"
          icon={<RoundCloseIcon size="20px" color="danger" />}
          title={<Text weight={700}>Fix your address or payment method</Text>}
          description='Mail sent to your address was returned as undeliverable. Since your current payment method is check, please update your details to submit this claim.'
          backgroundColor="dangerContainer"
          borderColor="transparent"
          topBorderColor="transparent"
          containerProps={{ pad: 'spacing16' }}
          border={undefined}
          {...props}
        >
          <Box margin={{ top: 'spacing12' }}>
            <AppButton
              testId="fix-your-address_button"
              width={isMobile ? '100%' : undefined}
              onClick={handleOpenModal}
            >
              Review Address
            </AppButton>
          </Box>
        </WarningCard>
      ): null}

      <ReviewAddressModal 
        isOpen={isReviewModalOpen}
        onClose={handleCloseModal}
      />
    </>
  );
};

export default FixYourAddressWarningCard;
